import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const rootNode = document.getElementById('root');
const root = ReactDOM.createRoot(rootNode);
root.render(
    <App /*event={"187"}*/ />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (typeof MutationObserver != 'undefined' && window.parent) {
    const observer = new MutationObserver(() => {
        const height = rootNode.clientHeight;
        if (height > 0) {
            window.parent.postMessage({ type: 'LIVE_SCORING_HEIGHT_CHANGE', height }, '*');
        }
    });
    observer.observe(rootNode, {
        subtree: true,
        childList: true,
    });
}
